import React from 'react'
import { SnackbarKey, useSnackbar } from 'notistack'
import { IconButton } from '@mui/material'
import { J2Multiply } from '@e3dc-react/icons'

/**
 * Close button component for snackbar
 */
const SnackbarCloseButton: React.FC<{ snackbarKey: SnackbarKey }> = ({ snackbarKey }) => {
  const { closeSnackbar } = useSnackbar()

  return (
    <IconButton onClick={() => closeSnackbar(snackbarKey)} size="large" color="inherit">
      <J2Multiply />
    </IconButton>
  )
}

export default SnackbarCloseButton
